import { useEffect } from 'react';

import {
  capturePromoSeriesFromUrl,
  markCampaignIntentSynced,
  resolveActivePromoSeries,
  wasCampaignIntentSynced,
} from '../../utils/campaignPromo';
import { trySyncCampaignIntent } from '../../utils/serviceCalls/campaignIntent';
import { AUTH_STATUS, useAuth } from '../Auth';

/**
 * Captures ?promoSeries= from HGPRO redirects and syncs campaign intent after auth.
 */
export function CampaignPromoBootstrap() {
  const { status, user } = useAuth();

  useEffect(() => {
    capturePromoSeriesFromUrl();
  }, []);

  useEffect(() => {
    if (status !== AUTH_STATUS.AUTHENTICATED || !user?.userId) {
      return;
    }

    const campaignId = resolveActivePromoSeries();
    if (!campaignId || wasCampaignIntentSynced(user.userId, campaignId)) {
      return;
    }

    void trySyncCampaignIntent(user.userId, campaignId).then((ok) => {
      if (ok) {
        markCampaignIntentSynced(user.userId, campaignId);
      }
    });
  }, [status, user?.userId]);

  return null;
}
